module.exports = __webpack_public_path__ + "static/media/floating_heart_greenb497c39844b39e1e825707d92b7e25c4.gif";